import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: "'Marcellus', serif",
    body: "'Manrope', sans-serif"
  },
  colors: {
    brand: {
      50: '#F7F2E9',
      100: '#EFE4CF',
      200: '#E1CFA4',
      300: '#D3B679',
      400: '#C9A24C',
      500: '#B98B2D',
      600: '#9A6F1F',
      700: '#795515',
      800: '#523A0F',
      900: '#2D2008'
    }
  },
  styles: {
    global: {
      body: {
        bg: '#0F1A24',
        color: 'white'
      }
    }
  }
});

export default theme;
